<div class="review-system" data-automation-id="review-system-container">
    <div class="header-bar top" data-automation-id="review-system-header">
        <button type="button" data-automation-id="review-system-save-button" class="primary-button"
            *ngIf="hasCreatePermissions" (click)="saveChanges()" [disabled]="!isDirty || isSaveDisabled() || !(connectorValid || relativityConnectorValid)">Save</button>
        <button type="button" data-automation-id="review-system-discard-changes-button" *ngIf="hasCreatePermissions"
            class="secondary-button" (click)="discardChanges()" [disabled]="isDiscardDisabled()">Discard
            Changes</button>
        <button type="button" class="help-button" data-automation-id="review-system-help-button" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="content" #contentForm="ngForm" data-automation-id="review-system-content" [resBusySpinner]="isBusy"
        [message]="isBusyMessage">

        <div class="settings-panel-header">Reef Review</div>

        <div class="modal-row">
            <div class="modal-row-column-label">
                <label data-automation-id="review-system-host-url-label">Host URL:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="text" name="hostUrl" [(ngModel)]="viewModel.model.hostUrl" maxlength="255"
                    [disabled]="!hasCreatePermissions" [value]="viewModel.model.hostUrl"
                    data-automation-id="review-system-host-url-input"
                    (ngModelChange)="hostUrl.invalid = false; onChange();"
                    [(resScrollablePopover)]="hostUrl.invalid" [hasInputError]="hostUrl.invalid" formErrorInput
                    (blur)="validateUrl($event)" (input)="validateUrl($event)"
                    [popoverErrorMessage]="hostUrl.errorMessage" popoverType="error" popoverPlacement="right"
                    (focusin)="validateUrl($event)"
                    [popoverAutomationId]="'review-system-host-url-error-message'" [isSingleLine]="true">
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-label">
                <label data-automation-id="review-system-share-host-ip-address-label">Share Host / IP
                    Address:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="text" name="remoteHost" [(ngModel)]="viewModel.model.remoteHost" maxlength="255"
                    [disabled]="!hasCreatePermissions" [value]="viewModel.model.remoteHost"
                    data-automation-id="review-system-share-host-ip-address-input"
                    (ngModelChange)="remoteHost.invalid = false; onChange();"
                    [(resScrollablePopover)]="remoteHost.invalid" [hasInputError]="remoteHost.invalid"
                    formErrorInput (blur)="validateIP($event)" (input)="validateIP($event)"
                    [popoverErrorMessage]="remoteHost.errorMessage" popoverType="error" popoverPlacement="right"
                    placeholder="IP Address or Host Name" (focusin)="validateIP($event)"
                    [popoverAutomationId]="'review-system-share-host-ip-address-error-message'" [isSingleLine]="true">
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-label">
                <label data-automation-id="review-system-path-label">Path:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="text" name="remotePath" [(ngModel)]="viewModel.model.remotePath" [disabled]="!hasCreatePermissions"
                    [value]="viewModel.model.remotePath" data-automation-id="review-system-path-input" maxlength="255"
                    (ngModelChange)="remotePath.invalid = false; onChangeRelativityUrl();"
                    [(resScrollablePopover)]="remotePath.invalid" [hasInputError]="remotePath.invalid" formErrorInput
                    (blur)="validatePath($event)" (input)="validatePath($event)"
                    [popoverErrorMessage]="remotePath.errorMessage" popoverType="error" popoverPlacement="right"
                    (focusin)="validatePath($event)"
                    [popoverAutomationId]="'review-system-path-error-message'" [isSingleLine]="true">
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-label">
            </div>
            <div class="modal-row-column-auto">
                <button type="button" data-automation-id="review-system-validate-button" *ngIf="hasCreatePermissions"
                    class="secondary-button" (click)="validateConnector()" [disabled]="!isReefReviewValidateEnabled()"><i
                        class="fa fa-check"></i>Validate</button>
            </div>
        </div>

         <div class="settings-panel-header relativity-header">Relativity Server</div>

        <div class="modal-row">
            <div class="modal-row-column-label">
                <label for="relativityHostUrl" data-automation-id="review-system-host-url-label">Host URL:
                </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="text" id="relativityHostUrl" name="relativityUrl" [(ngModel)]="relativityHostUrl" maxlength="255"
                    [disabled]="!hasCreatePermissions" [value]="relativityHostUrl"
                    data-automation-id="review-system-relativity-host-url-input"
                    (ngModelChange)="relativityUrl.invalid = false; onChangeRelativityUrl();"
                    [(resScrollablePopover)]="relativityUrl.invalid" [hasInputError]="relativityUrl.invalid" formErrorInput
                    (blur)="validateUrl($event, true)" (input)="validateUrl($event, true)"
                    [popoverErrorMessage]="relativityUrl.errorMessage" popoverType="error" popoverPlacement="right"
                    (focusin)="validateUrl($event, true)"
                    [popoverAutomationId]="'review-system-relativity-host-url-error-message'" [isSingleLine]="true">
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-label"></div>
            <div class="modal-row-column-auto">
                <button type="button" data-automation-id="review-system-relativity-validate-button" *ngIf="hasCreatePermissions"
                    class="secondary-button" (click)="validateConnector(true)" [disabled]="!relativityHostUrl || relativityUrl.invalid"><i
                        class="fa fa-check"></i>Validate</button>
            </div>  
        </div>
    </form>
</div>